{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "Chrome-viðbótin er ekki uppsett.",
      "CTA": "Setja upp viðbót"
    },
    "TABS": {
      "PHONE": "Sími",
      "SMS": "SMS",
      "HISTORY": "Saga"
    },
    "HISTORY": {
      "OPEN": "Opin",
      "RECENT": "Nýleg",
      "MISSED": "Ósvarað",
      "LOADING": "Hleð símtölum...",
      "EMPTY": "Engin símtöl hér",
      "ERROR": "Ekki tókst að hlaða símtölunum",
      "CALL": "Hringja til baka",
      "CALL_STATUS": {
        "BUTTON": "Stilla stöðu símtals",
        "TITLE": "Staða símtals",
        "SEARCH_PLACEHOLDER": "Leita að stöðum...",
        "LOADING": "Hleð stöðum...",
        "NO_OPTIONS": "Engar símtalsstöður eru stilltar",
        "NO_MATCH": "Engin staða fannst",
        "OPTIONS_ERROR": "Ekki tókst að hlaða stöðunum",
        "RETRY": "Reyna aftur",
        "CONFIRM_QUESTION": "Setja „{status}“ og leysa samtalið?",
        "CONFIRM": "Staðfesta",
        "BACK": "Til baka",
        "CANCEL": "Hætta við",
        "SAVING": "Vistar...",
        "SAVE_ERROR": "Ekki tókst að vista stöðuna",
        "RESOLVE_ERROR": "Staðan var vistuð, en ekki tókst að leysa samtalið"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Símanúmer, t.d. +421903000000",
      "BODY_PLACEHOLDER": "Skrifaðu skilaboðin þín ...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "Senda SMS",
      "SENDING": "Sendi ...",
      "SENT": "SMS sent",
      "LOADING": "Hleð SMS-innhólf ...",
      "NO_INBOX": "Þessi reikningur er ekki með SMS-innhólf, svo ekki er hægt að senda SMS.",
      "INVALID_NUMBER": "Sláðu inn númerið á alþjóðlegu sniði, með + fremst.",
      "ERROR": "Ekki tókst að senda SMS-ið. Reyndu aftur."
    },
    "ACTIONS": {
      "CONNECT": "Tengja",
      "GO_TO_TAB": "Fara í þann flipa",
      "DISCONNECT": "Aftengja",
      "ANSWER": "Svara",
      "HANGUP": "Leggja á",
      "HOLD": "Setja á bið",
      "MUTE": "Þagga hljóðnema",
      "SILENCE": "Þagga hljóð",
      "TRANSFER": "Framsenda",
      "COMPLETE_TRANSFER": "Ljúka framsendingu",
      "RETURN_TO_CALLER": "Fara aftur til hringjanda",
      "CANCEL_TRANSFER": "Hætta við framsendingu",
      "DIALPAD": "Sýna talnaborð",
      "OPEN_CONVERSATION": "Opna samtal"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Innhringing",
      "INCOMING_CALL_FROM": "Innhringing frá {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "Innhringing frá {number}",
      "ANSWER": "Svara",
      "DECLINE": "Hafna"
    },
    "TRANSFER": {
      "TITLE": "Framsenda símtal",
      "PLACEHOLDER": "Sláðu inn símanúmer til framsendingar...",
      "SEARCH_PLACEHOLDER": "Leita að starfsmönnum...",
      "TARGET_PLACEHOLDER": "Valinn framsendingaraðili",
      "CONFIRM": "Framsenda",
      "MODE_DIRECT": "Framsenda núna",
      "MODE_CONSULT": "Hringja í starfsmann fyrst",
      "CANCEL": "Hætta við"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "Ertu viss um að þú viljir fara í hlé fyrir allar raðir?",
      "CONFIRM_READY": "Ertu viss um að þú viljir fara aftur í tilbúna stöðu fyrir allar raðir?",
      "CONFIRM_BREAK_QUEUE": "Ertu viss um að þú viljir skrá þig út úr röðinni {queue}?",
      "CONFIRM_READY_QUEUE": "Ertu viss um að þú viljir skrá þig inn í röðina {queue}?",
      "LOGIN_TO_QUEUE": "Skrá inn",
      "LOGOUT_FROM_QUEUE": "Skrá út",
      "LOGIN_TO_ALL_QUEUES": "Skrá inn í allar raðir",
      "LOGOUT_FROM_ALL_QUEUES": "Skrá út úr öllum röðum",
      "OPTION_LOGOUT": "Skrá út",
      "OPTION_BREAK": "Hlé",
      "OPTION_LUNCH": "Hádegismatur",
      "OPTION_AWAY": "Fjarverandi",
      "OPTION_DO_NOT_DISTURB": "Ónáðið ekki",
      "OPTION_BUSINESS_TRIP": "Vinnuferð",
      "CONFIRM": "Staðfesta",
      "CANCEL": "Hætta við"
    },
    "CONNECTION_ERROR": {
      "TITLE": "Engin tenging við símkerfið",
      "MESSAGE": "Nettengingin þín virðist liggja niðri. Athugaðu hana og reyndu aftur.",
      "CREDENTIALS_TITLE": "Símkerfið hafnaði innskráningarupplýsingum þínum",
      "CREDENTIALS_MESSAGE": "Símkerfið hafnaði notandanafninu eða lykilorðinu sem er vistað í prófílnum þínum. Athugaðu þau í Stillingar Prófíls eða hafðu samband við kerfisstjórann.",
      "CONFIGURATION_TITLE": "Símastillingar eru ógildar",
      "CONFIGURATION_MESSAGE": "SIP notandanafnið eða vistfang netþjónsins er ekki á réttu sniði, svo síminn getur ekki tengst. Lagaðu það í Stillingar Prófíls.",
      "NETWORK_SHORT": "Tenging mistókst",
      "CREDENTIALS_SHORT": "Innskráningu hafnað",
      "CONFIGURATION_SHORT": "Ógildar símastillingar",
      "RETRY": "Reyna aftur",
      "DISMISS": "Hætta við"
    },
    "CONNECTION_QUALITY": "Gæði tengingar",
    "CONNECTION_QUALITY_EXCELLENT": "Framúrskarandi",
    "CONNECTION_QUALITY_GOOD": "Gott",
    "CONNECTION_QUALITY_FAIR": "Sæmilegt",
    "CONNECTION_QUALITY_POOR": "Slæmt",
    "CONNECTION_QUALITY_DISCONNECTED": "Aftengt",
    "STATUS": {
      "OFFLINE": "Sími ótengdur",
      "IN_OTHER_TAB": "Sími tengdur í öðrum flipa",
      "CONNECTING": "Tengist...",
      "DISCONNECTING": "Aftengist...",
      "ONLINE": "Sími tengdur",
      "DIALING": "Hringir",
      "TRANSFERRING": "Framsendir...",
      "CONSULTING": "Í samtali við starfsmann",
      "CALLER_ON_HOLD": "Hringjandi er á bið",
      "BUSY": "Upptekið",
      "DND": "DND",
      "UNAVAILABLE": "Ekki tiltækur",
      "REJECTED": "Símtali hafnað",
      "CALL_FAILED": "Símtal mistókst"
    },
    "QUEUES": {
      "MORE": "Fleiri raðir"
    }
  },
  "DIAL_REDIRECT": {
    "DIALING": "Hringi í {number}… Þú getur lokað þessum flipa.",
    "NO_NUMBER": "Ekkert númer gefið upp. Notaðu ?number=+420..."
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Sláðu inn símanúmer...",
    "ACTIONS": {
      "DIAL": "Hringja í númer",
      "DIAL_FROM": "Veldu númerið sem hringt er úr"
    },
    "DIAL_FROM": {
      "TITLE": "Hringja úr númeri innhólfs"
    },
    "VALIDATION": {
      "REQUIRED": "Símanúmer er nauðsynlegt",
      "INVALID_FORMAT": "Ógilt snið símanúmers"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Hljóðstillingar og prófun",
    "SELECT_DEVICE": "Veldu tæki...",
    "SYSTEM_DEFAULT": "Sjálfgefið kerfistæki",
    "SAVED": "Vistað",
    "DISCONNECTED_SUFFIX": "ekki tengt",
    "DEVICE_DISCONNECTED": "Valda tækið er ekki tengt. Símtöl nota sjálfgefið kerfistæki þar til það tengist aftur.",
    "MICROPHONE": {
      "TITLE": "Hljóðnemi",
      "START_TEST": "Prófa hljóðnema",
      "STOP_TEST": "Stöðva próf",
      "LEVEL": "Styrkur:",
      "VERDICT": {
        "LISTENING": "Segðu eitthvað í hljóðnemann…",
        "SILENT": "Það heyrist ekki í þér. Gakktu úr skugga um að hljóðneminn sé kveiktur og að rétt tæki sé valið.",
        "LOW": "Það heyrist illa í þér. Veldu annan hljóðnema eða stilltu inntaksstyrkinn í kerfisstillingum.",
        "GOOD": "Góður hljómur — það heyrist vel í þér."
      }
    },
    "SPEAKER": {
      "TITLE": "Hátalari",
      "TEST": "Prófa hátalara",
      "TESTING": "Í prófun...",
      "VOLUME": "Hljóðstyrkur:",
      "USING_DEFAULT": "Valið úttak er ekki tiltækt — spilað á sjálfgefna kerfistækinu."
    },
    "DONE": "Lokið",
    "ERRORS": {
      "MICROPHONE_ACCESS": "Villa við að fá aðgang að hljóðnema. Vinsamlegast athugaðu heimildir.",
      "MICROPHONE_PERMISSION_DENIED": "Aðgangur að hljóðnema er lokaður. Leyfðu hann í vefsvæðisstillingum vafrans til að nota símann.",
      "MICROPHONE_SILENT": "Hljóðneminn þinn nemur ekkert hljóð. Athugaðu hljóðstillingarnar þínar.",
      "EXTENSION_REQUIRED": "Símaviðbótin fannst ekki. Settu hana upp eða virkjaðu hana til að nota hljóðnemann.",
      "SPEAKER_TEST": "Villa við að prófa úttak hátalara."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Ótengdur",
    "ONLINE": "Tengdur",
    "BUSY": "Upptekið"
  },
  "QUEUE_STATUS": {
    "READY": "Tilbúinn",
    "NOT_READY": "Tekur ekki á móti símtölum",
    "WRAP_UP": "Frágangur",
    "BREAK": "Hlé",
    "LUNCH": "Hádegismatur",
    "AWAY": "Fjarverandi",
    "DO_NOT_DISTURB": "Ónáðið ekki",
    "BUSINESS_TRIP": "Vinnuferð",
    "OTHER_CALL": "Annað símtal",
    "QUEUE_CALL": "Símtal í röð",
    "OFFLINE": "Ótengdur",
    "ONLINE": "Tengdur",
    "NO_ACCESS": "Enginn sími",
    "PARTIALLY_READY": "Að hluta tilbúinn",
    "MIXED": "Blandað",
    "CHAT_ONLINE": "Tengdur (spjall)",
    "CHAT_BUSY": "Upptekið (spjall)",
    "CHAT_OFFLINE": "Ótengdur (spjall)"
  }
}
